export const quizMarkCalculator = (answers) => {
  let quizAnswers = Object.values(answers);

  let totalMark = 0; 
  let totalCorrect = 0; 
  let totalWrong = 0; 

  for (let i = 0; i < quizAnswers.length; i++) {
    const options = quizAnswers[i];
    let correctFound = false; 
    let incorrectFound = false; 

    for (let j = 0; j < options.length; j++) {
      const option = options[j];

      if (option.isCorrect) {
        correctFound = true; 
      } else {
        incorrectFound = true; 
      }
    }

    if (correctFound && !incorrectFound) {
      totalMark += 5; 
      totalCorrect++; 
    } else {
      totalWrong++; 
    }
  }

  return { totalMark, totalCorrect, totalWrong}
};
